import React, { SyntheticEvent } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { deleteAuthCookie } from '@dnb/authentication';
import { Button } from '@dnb/eufemia';
import { person_medium } from '@dnb/eufemia/icons';
import classNames from 'classnames';
import { navigate } from 'gatsby';
import { useHeaderStore } from '@dnb/header';
import {MenuButton} from '@dnb/header';
import About from './About/About';
import styles from './ProfileDropdown.module.scss';
import { useOpenDropdown } from './useOpenDropdown/useOpenDropdown';

type ProfileDropdownProps = { shouldOpen?: boolean };

const ProfileDropdown = ({ shouldOpen }: ProfileDropdownProps) => {
  const openButtonId = 'dnb_header_me_button';
  const { isDropdownOpen, refToPreventClose, toggleDropdown, closeDropdown } =
    useOpenDropdown(openButtonId, shouldOpen);
  const { formatMessage } = useIntl();
  const profile = useHeaderStore((state) => state.profile);

  return (
    <>
      <MenuButton
        id={openButtonId}
        text={<FormattedMessage id="dnb_header_me_button" />}
        icon={person_medium}
        aria-haspopup="true"
        aria-expanded={isDropdownOpen}
        on_click={(event: SyntheticEvent) => {
          // We stop the event from bubbling up the dom so it is not caught by the handler closing the dropdow
          event.nativeEvent.stopPropagation();
          toggleDropdown();
        }}
      />
      <div ref={refToPreventClose}
           className={classNames(styles.dropdown, 'dnb-no-focus', {
             [styles.dropdownOpen]: isDropdownOpen,
           })}
           aria-label={formatMessage({ id: 'dnb-aria_header_me_dropdown' })}
           tabIndex={-1}>
      <section

      >
        <DropdownItem className={styles.about}>
          <About
            name={profile?.name}
            avatarSrc={profile?.avatarSrc}
            programType={profile?.program}
          />
        </DropdownItem>
        <DropdownItem className={styles.logOutButtonContainer}>
          <Button
            on_click={() => {
              deleteAuthCookie();
              navigate('/');
              closeDropdown();
            }}
          >
            <FormattedMessage id="dnb_header_me_log_out" />
          </Button>
        </DropdownItem>
      </section>
      </div>
    </>
  );
};

const DropdownItem: React.FC<{ className?: string }> = ({
  children,
  className,
}) => {
  return (
      <div className={classNames(styles.dropdownItem, className)}>{children}</div>
  );
};

export default ProfileDropdown;
